module.exports = __webpack_public_path__ + "static/media/espaceGT2.39b8dbf8.svg";